import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { messages } from '@gongxigames/framework/slot';
import {
    MultiSetsMulticampaignPromotionStates,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents,
    MultiSetsMulticampaignPromotionLogic,
} from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionTerminatedState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents
> {
    public onEnterState(): void {
        this.module.emitShowBetPanel();
        this.module.getPromotion<MultiSetsMulticampaignPromotionLogic>().endExpiredRounds();
        this.module.getEventManager().emit('General.Promotion.Campaign.Ended');
        this.module.getEventManager().emit('General.Promotion.DeactivateCounter');
        
        const hasNextPromotion = this.module.getPromotion().hasPromotion() && this.module.nextActionIsSpin;
        const message = { ...messages.PROMOTION_TERMINATED_WARNING };

        if (message.buttons && message.buttons.length > 0) {
            message.buttons[0].actionCallback = () => {
                if (hasNextPromotion) {
                    this.module.gotoState(MultiSetsMulticampaignPromotionStates.START);
                } else {
                    this.module.getEventManager().emit('General.Promotion.Ended');
                    this.module.getEventManager().emit('General.Slot.SPIN.ENABLE', MultiSetsMulticampaignPromotionModule.NAME);
                    this.module.gotoState(MultiSetsMulticampaignPromotionStates.BASIC);
                }
            };
        }

        this.module.getEventManager().emit('General.Message.SHOW', message);
    }

    public onLeaveState(): void {}

    protected setupEvents(): void {}
}
